

import Cimg1 from '../images/impact/1.jpg'
import Cimg2 from '../images/impact/2.jpg'
import Cimg3 from '../images/impact/3.jpg'
import Cimg4 from '../images/causes/2.jpg'



import Csimg1 from '../images/cause-single/1.jpg'
import Csimg2 from '../images/cause-single/2.jpg'
import Csimg3 from '../images/cause-single/3.jpg'
import Csimg4 from '../images/cause-single/4.jpg'



const causesData = [
    {
        id: 1,
        slug:"1",
        title: "Mekdes, Age 4",
        category: "Education",
        image: Cimg2,
        video: "/videos/home_video_4.mp4" ,
        Simage: Csimg2,
        raisedAmount: 8000,
        goalAmount: 10000,
        description: "At just 3 months old, Eliana became seriously ill due to a congenital heart disease. She was struggling every day, leaving her parents desperate for help."
    },
    {
        id: 2,
        slug:"2",
        title: "Abel, Age 10",
        category: "Food",
        image: Cimg1,
        video: "videos/home_video_5.mp4" ,
        Simage: Csimg1,
        raisedAmount: 4000,
        goalAmount: 10000,
        description: "With the support of Heart-to-Heart Children Aid, Eliana received the opportunity to undergo life-saving heart surgery."
    },
    {
        id: 3,
        slug:"3",
        title: "Yanet, Age 7",
        category: "Education",
        image: Cimg2,
        video: "videos/home_video_1.mp4" ,
        Simage: Csimg3,
        raisedAmount: 8692,
        goalAmount: 10000,
        description: "After the operation, Eliana remained under close medical care in the recovery ward. The days were delicate, but filled with hope."
    },
    {
        id: 4,
        slug:"4",
        title: "Yeabsra, Age 7",
        category: "Education",
        image: Cimg3,
        video: "videos/home_video_2.mp4" ,
        Simage: Csimg4,
        raisedAmount: 5000,
        goalAmount: 10000,
        description: "Eliana began showing beautiful signs of improvement. Her breathing eased, her feeding became stronger, and her tiny face returned to the bright, curious expressions every infant should have."
    },
   {
        id: 5,
        slug:"4",
        title: "Yeabsra, Age 7",
        category: "Education",
        image: Cimg3,
        video: "videos/home_video_3.mp4" ,
        Simage: Csimg4,
        raisedAmount: 5000,
        goalAmount: 10000,
        description: "Now 1 year old, Eliana is healthy, playful, and thriving—a beautiful reminder of how life can change through timely care and compassion."
    },
   

];

export default causesData;